import {Link} from 'react-router-dom';
import {convertViewCnt, isLogin} from '@/utils/main';
import {sendClickLog} from '@/utils/main/my-plus/log';
import {useEffect, useState} from 'react';
import {DEFAULT_POSTER_THUMB_TMG} from '@/constants/common/images';
import useGlobalUIStore from '@/stores';
import {SoopUiSwiper} from '@/components/ui';

const CategoryDefaultTemplate = ({itemList, selectedMode, useSlider}) => {
  const {isDarkMode} = useGlobalUIStore();

  const handleImageError = (e) => {
    const imgElement = e.target;
    imgElement.src = DEFAULT_POSTER_THUMB_TMG(isDarkMode);
    imgElement.setAttribute('data-replaced', 'true');
  };

  const handleClickCategory = (item, idx) => {
    const location = selectedMode === 'prefer' ? 'myplus' : selectedMode;
    sendClickLog('cate_list', {
      buttonType: `${location}_cate`,
      location: location,
      filterId: item.categoryName,
      filterIdx: idx + 1,
    });
  };

  const renderItem = () => {
    return itemList.map((item, idx) => (
      <li key={idx} onClick={() => handleClickCategory(item, idx)}>
        <Link
          to={`/directory/category/${encodeURIComponent(item.categoryName)}/live`}>
          {item.viewCnt > 0 && (
            <span className='views'>
              <em>{convertViewCnt(item.viewCnt)}</em>
            </span>
          )}
          <div className='thumb'>
            <img
              src={item.cateImg}
              alt={item.categoryName}
              onError={handleImageError}
            />
          </div>
          <div className='info_wrap'>
            <p className='title'>{item.categoryName}</p>
          </div>
        </Link>
      </li>
    ));
  };

  return (
    <>
      {useSlider && (
        <div className={'category_conts_wrap'}>
          <SoopUiSwiper
            swiperClass='category_conts'
            options={{loop: itemList.length > 10}}
            maxSlidesPerView={10}
            otherMaxSlidesResolution={[
              {max: 1623, slidePerView: 10},
              {max: 1202, slidePerView: 8},
              {max: 1000, slidePerView: 6},
              {max: 751, slidePerView: 5},
              {max: 496, slidePerView: 4},
              {max: 0, slidePerView: 3},
            ]}
            swiperTag='ul'>
            {renderItem()}
          </SoopUiSwiper>
        </div>
      )}
      {!useSlider && (
        <div className='category_conts'>
          <ul>{renderItem()}</ul>
        </div>
      )}
    </>
  );
};

export default CategoryDefaultTemplate;
